/**
 * havloFirebaseConfig.js
 * Secondary Firebase app connecting to Havlo's Firestore
 * Used by LiveSupportDashboard to read Havlo chat conversations
 */
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const havloConfig = {
  apiKey: "AIzaSyB7Nu_j6cDdZWU-fw7pqrItXLtuZfjdxTw",
  authDomain: "havlo-c644c.firebaseapp.com",
  projectId: "havlo-c644c",
  storageBucket: "havlo-c644c.firebasestorage.app",
  messagingSenderId: "333888193262",
  appId: "1:333888193262:web:b372aef9f65dfadb5569ff",
};

// Initialize as secondary app (not default)
const havloApp = initializeApp(havloConfig, "havlo");
export const havloDb = getFirestore(havloApp);
